import React, {Fragment} from "react";
import classNames from "classnames";
import {DefaultDataGridProps} from "../Types/DefaultDataGridProps";
import {Body} from "./Body";
import Header from "./Header";
import {Footer} from "./Footer";
import Pagination from "./Pagination";

export default (props: DefaultDataGridProps) => {
    const className = props.className;
    props = {...props};
    delete props.className;
    let header = null;
    if (props.header) {
        if (props.header instanceof Function) {
            header = <props.header {...props} />
        } else {
            header = <props.header.type ref={props.header.ref} {...props} {...props.header.props} />
        }
    } else {
        header = <Header {...props} />;
    }
    return <Fragment>
        <div className={classNames(className)}>
            <div className="table-responsive">
                <div className="p-datagrid p-datatable p-component p-datatable-resizable p-datatable-resizable-fit p-datatable-hoverable-rows table table-hover">
                    {props.isLoading && <div className="p-datatable-loading">
                        <div className="p-datatable-loading-overlay p-component-overlay" />
                        <div className="p-datatable-loading-content"><i
                            className="p-datatable-loading-icon pi-spin pi pi-spinner" />
                        </div>
                    </div>}
                    <div className="p-datatable-wrapper">
                        <table>
                            {header}
                            <Body {...props} />
                            <Footer {...props} />
                        </table>
                        <Pagination {...props} />
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
}